/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Acceptall1Inputs */

const en_btn_acceptall1 = /** @type {(inputs: Btn_Acceptall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept all`)
};

/**
* | output |
* | --- |
* | "Accept all" |
*
* @param {Btn_Acceptall1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_acceptall1 = /** @type {((inputs?: Btn_Acceptall1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Acceptall1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_acceptall1(inputs)
});
export { btn_acceptall1 as "btn_acceptAll" }